import React from 'react';
import { Row, Col } from 'antd';
import { useFormContext } from 'react-hook-form';
import FormField from '../../shared/FormField';
import SelectField from '../../shared/SelectField';
import FileUploadField from '../../shared/FileUploadField';
import { CategoriaArquivo } from '@engenharia/shared';
import { useFormStore } from '../../../store/formStore';

const TIPO_PADRAO_OPTIONS = [
  { label: 'Individual', value: 'Individual' },
  { label: 'Coletivo', value: 'Coletivo' },
];

const CONTAS_TITULAR_OPTIONS = [
  { label: 'Sim', value: 'Sim' },
  { label: 'Não', value: 'Nao' },
];

const CORRENTE_OPTIONS = [
  '30A', '40A', '50A', '63A', '70A', '80A', '100A', '150A', '200A',
].map((c) => ({ label: c, value: c }));

const FASES_OPTIONS = [
  { label: 'Monofásico', value: 'Monofasico' },
  { label: 'Bifásico', value: 'Bifasico' },
  { label: 'Trifásico', value: 'Trifasico' },
];

interface Props {
  onUpload: (categoria: any, file: File) => void;
  onDelete: (id: number) => void;
  uploadStates: Record<string, { uploading: boolean; progress: number }>;
}

export default function PadraoAtualSection({ onUpload, onDelete, uploadStates }: Props) {
  const { watch } = useFormContext();
  const arquivos = useFormStore((s) => s.arquivos);
  const tipoPadrao = watch('tipo_padrao');

  const fotoCategories: { label: string; cat: CategoriaArquivo; required: boolean }[] = [
    { label: 'Fotos do Padrão', cat: CategoriaArquivo.FotosPadrao, required: true },
    { label: 'Imagens Diversas do Padrão', cat: CategoriaArquivo.ImagensDiversasPadrao, required: true },
    { label: 'Foto do Telhado', cat: CategoriaArquivo.FotoTelhado, required: true },
    { label: 'Foto Estrutura Abaixo do Telhado', cat: CategoriaArquivo.FotoEstruturaAbaixoTelhado, required: true },
    { label: 'Foto da Fachada', cat: CategoriaArquivo.FotoFachada, required: true },
    { label: 'Foto Local do Inversor', cat: CategoriaArquivo.FotoLocalInversor, required: true },
    { label: 'Foto Acesso ao Telhado', cat: CategoriaArquivo.FotoAcessoTelhado, required: false },
    { label: 'Foto Quadro de Conexão', cat: CategoriaArquivo.FotoQuadroConexao, required: false },
    { label: 'Foto Quadro de Passagem', cat: CategoriaArquivo.FotoQuadroPassagem, required: false },
  ];

  return (
    <div className="border rounded-lg p-4 mb-4">
      <h3 className="text-lg font-semibold mb-4">Padrão Atual</h3>

      <Row gutter={16}>
        <Col xs={24} sm={8}>
          <SelectField name="tipo_padrao" label="Tipo de Padrão" options={TIPO_PADRAO_OPTIONS} />
        </Col>
        <Col xs={24} sm={8}>
          <SelectField name="todas_contas_mesmo_titular" label="Todas contas mesmo titular?" options={CONTAS_TITULAR_OPTIONS} />
        </Col>
        <Col xs={24} sm={8}>
          <SelectField name="corrente_padrao" label="Corrente do Padrão" options={CORRENTE_OPTIONS} />
        </Col>
      </Row>

      <Row gutter={16}>
        <Col xs={24} sm={8}>
          <SelectField name="fases_disjuntor" label="Fases do Disjuntor" options={FASES_OPTIONS} />
        </Col>
        <Col xs={24} sm={16}>
          <FormField name="descricao_padrao" label="Descrição do Padrão" textarea />
        </Col>
      </Row>

      {tipoPadrao === 'Coletivo' && (
        <FileUploadField
          label="Foto Relação de Caixas"
          categoria={CategoriaArquivo.FotoRelacaoCaixas}
          arquivos={arquivos}
          uploading={uploadStates[CategoriaArquivo.FotoRelacaoCaixas]?.uploading || false}
          progress={uploadStates[CategoriaArquivo.FotoRelacaoCaixas]?.progress || 0}
          required
          onUpload={onUpload}
          onDelete={onDelete}
        />
      )}

      <div className="mt-4">
        <h4 className="text-md font-medium mb-2">Fotos do Local</h4>
        <Row gutter={16}>
          {fotoCategories.map(({ label, cat, required }) => (
            <Col xs={24} sm={12} md={8} key={cat}>
              <FileUploadField
                label={label}
                categoria={cat}
                arquivos={arquivos}
                uploading={uploadStates[cat]?.uploading || false}
                progress={uploadStates[cat]?.progress || 0}
                required={required}
                multiple
                onUpload={onUpload}
                onDelete={onDelete}
              />
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
}
